/* eslint-env es6 */
const mutations = {
  setKeyWord (state, val) {
    console.log('mutations')
    console.log(val)
    state.keyWord = val
  },
  setLiveShopObj (state, val) {
    state.liveShopOBj = val
  },
  setChannelBrand (state, val) {
    state.channelBrand = val
  }
}
export default mutations
